import './AdditionalChatbotsPanel.pcss';
import React, { useEffect, useState } from 'react';
import ChatbotRow from './ChatbotRow/ChatbotRow';
import { Dispatch } from 'redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { FormattedBot } from '@mm/state/interfaces/view';
import CompanyModel from '@mm/state/model/CompanyModel';
import { UserRole } from '@mm/state/model/CompanyUsersModel';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import Button from '../../../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import {
  Grid,
  GridCell,
  GridLabels,
} from '../../../../../../../common/components/Grid/Grid';
import { StoreState } from '@mm/state/store-interfaces';
import { connectedPageSelector } from '@mm/state/selectors/viewSelectors';
import chatbotCRUDActions from '@mm/state/actions/ChatbotCRUDActions';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import modalActions from '@mm/state/modules/modalsState/actions';
import ConnectedPageModel from '@mm/state/model/ConnectedPageModel';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';

type OuterProps = {
  bots: FormattedBot[];
  company: CompanyModel;
};

type InnerProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

type Props = OuterProps & InnerProps;

const AdditionalChatbotsPanel = (props: Props) => {
  const {
    openConfirmChangeBotStatusModal,
    openConfirmDeleteChatbotModal,
    attachToFacebookPage,
    company,
    bots,
    openCreateBotModal,
    page,
    userId,
    getUser,
  } = props;
  const [showShareButton, setShowShareButton] = useState(false);

  const showShareButtonFetch = async () => {
    const user = await getUser(company.id, userId);

    if (
      user &&
      (user.role === UserRole.Owner || user.role === UserRole.Admin)
    ) {
      setShowShareButton(true);
    }
  };

  useEffect(() => {
    showShareButtonFetch();
  }, []);

  const companyId = company.id;
  const hasBots = !!bots.length;
  const canDeleteBots = bots.length > 1;

  const gridTemplateColumns = '20% 30% 30% 20%';

  return (
    <SettingSection
      className="additional-chatbots-panel"
      title="Additional Chatbots"
    >
      {page && (
        <Button
          className="additional-chatbots-panel__create-bot-button"
          purple
          invert={true}
          onClick={() => openCreateBotModal(companyId, page.id)}
        >
          + Create New Chatbot
        </Button>
      )}

      <Grid className="additional-chatbots-panel__grid-background">
        <GridLabels gridTemplateColumns={gridTemplateColumns}>
          <GridCell>
            <span>Name</span>
          </GridCell>

          <GridCell className="additional-chatbots-panel__label" fr={2}>
            <span>Status</span>
          </GridCell>

          <GridCell className="additional-chatbots-panel__label" fr={2}>
            <span>Created On</span>
          </GridCell>

          <GridCell className="additional-chatbots-panel__actions-label">
            Actions
          </GridCell>
        </GridLabels>

        {hasBots && (
          <div>
            {bots.map(bot => (
              <ChatbotRow
                key={bot.id}
                bot={bot}
                page={page}
                companyId={companyId}
                attachToFacebookPage={attachToFacebookPage}
                gridTemplateColumns={gridTemplateColumns}
                openConfirmDeleteChatbotModal={openConfirmDeleteChatbotModal}
                openConfirmChangeBotStatusModal={
                  openConfirmChangeBotStatusModal
                }
                showShareButton={showShareButton}
                canDeleteBots={canDeleteBots}
              />
            ))}
          </div>
        )}
      </Grid>
    </SettingSection>
  );
};

const mapStateToProps = (state: StoreState) => ({
  userId: state.session.session.id,
  page: connectedPageSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  openConfirmDeleteChatbotModal: (bot: ChatbotModel, companyId: number) =>
    dispatch(modalActions.openConfirmDeleteChatbotModal(bot, companyId)),
  openCreateBotModal: (companyId: number, facebookPageId: number) =>
    dispatch(modalActions.openCreateBotModal(companyId, facebookPageId)),
  attachToFacebookPage: (botId: number, facebookPage: ConnectedPageModel) =>
    dispatch(chatbotCRUDActions.attachToFacebookPage(botId, facebookPage.id)),
  openConfirmChangeBotStatusModal: (botId: number, page: ConnectedPageModel) =>
    dispatch(modalActions.openConfirmChangeBotStatusModal(page, botId)),
  getUser: (companyId: number, userId: number) =>
    dispatch(usersCRUDActions.retrieveById(companyId, userId)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(AdditionalChatbotsPanel);
